// src/components/DiemDanh.js
import React, { useState, useEffect, useCallback } from "react";
import { fetchData, addData } from "../services/api";
import { useThongBao } from "../vo";

// ============================================================
// ✋ ĐIỂM DANH (Đợt 4B)
// ------------------------------------------------------------
// Bản lề của cả app. Chân dung mục 3: "Ép mọi người từ phải sử dụng đến
// thích nó." Điểm danh là nghĩa vụ dễ nhất có thể — không làm được việc
// nào vẫn điểm danh được — và nó đưa người vào app mỗi ngày, để họ nhân
// tiện gặp cái đáng thích (sân chơi, Đợt 6).
//
// ⚠️ BA RANH GIỚI, ĐỪNG NỚI LỎNG VỀ SAU:
//
// 1. CHỈ HIỆN NGƯỜI CÓ MẶT, KHÔNG HIỆN AI VẮNG.
//    Chủ nhà chọn cho cả nhà thấy hàng tên người có mặt hôm nay. Nhưng
//    "hôm nay ai CHƯA điểm danh" là chuyện khác hẳn — nó thuộc trang Sổ
//    theo dõi, chỉ chủ nhà đọc (chân dung mục 5.4), làm ở Đợt 7. Hiện
//    danh sách người vắng cho cả nhà là biến app thành công cụ trừng
//    phạt, đúng thứ mục 5.1 đã đóng.
//
// 2. KHÔNG CON SỐ NÀO CẢ.
//    Không "bạn đã điểm danh 12 ngày liên tiếp", không "3/5 người đã có
//    mặt", không xếp hạng. Chuỗi ngày liên tiếp nghe vô hại nhưng nó là
//    một thang đo trá hình: hụt một ngày là mất chuỗi, và người ta sẽ
//    thấy có lỗi. App trình bày sự thật, app không chấm điểm.
//
// 3. Ô GHI CHÚ KHÔNG BAO GIỜ BẮT BUỘC.
//    Ranh giới chủ nhà đặt: app không đòi hỏi thông tin khi thành viên
//    chưa muốn cung cấp. Bỏ trống vẫn điểm danh được, không cằn nhằn.
//
// Và: đây KHÔNG phải "đã làm xong việc". Ba khái niệm tách hẳn nhau —
// 🔕 Tắt nhắc (tắt chuông) · ✔ Đã làm (xong một việc cụ thể) · ✋ Điểm
// danh (hôm nay tôi có ghé). Gộp bất kỳ hai cái nào là mọi con số về sau
// đều sai.
// ============================================================

function DiemDanh({ user }) {
  const [dangTai, setDangTai] = useState(true);
  const [daDiemDanh, setDaDiemDanh] = useState(false);
  const [coMat, setCoMat] = useState([]);
  const [ghiChuDaLuu, setGhiChuDaLuu] = useState(null);

  const [moOGhiChu, setMoOGhiChu] = useState(false);
  const [ghiChuTam, setGhiChuTam] = useState("");
  const [dangGui, setDangGui] = useState(false);

  const tai = useCallback(() => {
    return fetchData("diem-danh/hom-nay")
      .then((d) => {
        setDaDiemDanh(Boolean(d.da_diem_danh));
        setCoMat(Array.isArray(d.co_mat) ? d.co_mat : []);
        setGhiChuDaLuu(d.ghi_chu || null);
      })
      .catch(() => {
        // Hỏng mạng thì im lặng — điểm danh không phải thứ đáng để một
        // dòng báo lỗi đỏ chào đón người ta lúc vừa mở app.
        setCoMat([]);
      })
      .finally(() => setDangTai(false));
  }, []);

  useEffect(() => {
    tai();
  }, [tai]);

  // Dùng hook chung cho phần trạng thái, nhưng VẪN tự vẽ bằng
  // `.diem-danh-bao` chứ không dùng <ThongBao>: khối điểm danh có nền xanh
  // riêng, đổi sang khung vàng chung là làm khác giao diện đang đúng.
  // Đúng tinh thần bộ vỏ: gộp lớp vỏ, không gộp ruột.
  const { bao, noiBao } = useThongBao();

  const guiDiemDanh = async (ghiChu) => {
    setDangGui(true);
    try {
      await addData("diem-danh", { ghi_chu: ghiChu || "" });
      setMoOGhiChu(false);
      setGhiChuTam("");
      await tai();
      noiBao(ghiChu ? "Đã ghi nhận, cảm ơn bạn." : "Đã điểm danh hôm nay.");
    } catch (e) {
      noiBao("Chưa gửi được, thử lại giúp nhé.");
    } finally {
      setDangGui(false);
    }
  };

  // Không vẽ gì lúc đang tải — nhấp nháy một khối rồi thay bằng khối khác
  // khó chịu hơn là chờ thêm nửa giây.
  if (dangTai) return null;

  const tenNguoiCoMat = coMat.map((n) => n.full_name).join(" · ");

  // ---------- Đã điểm danh: thu lại thành một dòng mảnh ----------
  if (daDiemDanh) {
    return (
      <div className="diem-danh diem-danh-xong">
        <div className="diem-danh-dong-gon">
          {/* Dấu tick nằm BÊN TRONG câu chữ, không phải một ô flex riêng.
              Để nó đứng riêng thì trên màn hình hẹp nó tụt lại một mình
              một dòng, còn câu chữ xuống dòng dưới. */}
          <span className="diem-danh-cau">
            <span className="diem-danh-dau-tick">✅</span> Bạn đã điểm danh hôm nay
            {ghiChuDaLuu && (
              <span className="diem-danh-loi-nhan-cua-toi">
                {" "}— “{ghiChuDaLuu}”
              </span>
            )}
          </span>
          <button
            type="button"
            className="diem-danh-nut-sua"
            onClick={() => {
              setGhiChuTam(ghiChuDaLuu || "");
              setMoOGhiChu((m) => !m);
            }}
          >
            {ghiChuDaLuu ? "sửa lời nhắn" : "thêm lời nhắn"}
          </button>
        </div>

        {moOGhiChu && (
          <div className="diem-danh-o-ghi-chu">
            <input
              type="text"
              value={ghiChuTam}
              onChange={(e) => setGhiChuTam(e.target.value)}
              placeholder="Hôm nay có gì muốn nói không?"
              maxLength={500}
              autoFocus
            />
            <button
              type="button"
              className="nut nut-xanh"
              disabled={dangGui}
              onClick={() => guiDiemDanh(ghiChuTam.trim())}
            >
              Lưu
            </button>
            <button
              type="button"
              className="nut nut-xam"
              onClick={() => setMoOGhiChu(false)}
            >
              Thôi
            </button>
          </div>
        )}

        {coMat.length > 0 && (
          <p className="diem-danh-hang-ten">
            Hôm nay có mặt: <strong>{tenNguoiCoMat}</strong>
          </p>
        )}

        {bao && <div className="diem-danh-bao">{bao}</div>}
      </div>
    );
  }

  // ---------- Chưa điểm danh: khối mời, nút to, dễ bấm ----------
  return (
    <div className="diem-danh diem-danh-chua">
      <div className="diem-danh-loi-moi">
        <span className="diem-danh-ban-tay">✋</span>
        <div>
          <strong>Chào {user?.full_name || user?.username}, hôm nay bạn ghé chưa?</strong>
          <p className="diem-danh-phu-de">
            Bấm một cái là xong. Không làm được việc nào cũng cứ điểm danh.
          </p>
        </div>
      </div>

      <div className="diem-danh-hang-nut">
        <button
          type="button"
          className="nut nut-xanh diem-danh-nut-chinh"
          disabled={dangGui}
          onClick={() => guiDiemDanh(moOGhiChu ? ghiChuTam.trim() : "")}
        >
          {dangGui ? "Đang gửi…" : "✋ Hôm nay tôi có mặt"}
        </button>
        {!moOGhiChu && (
          <button
            type="button"
            className="nut nut-xam"
            onClick={() => setMoOGhiChu(true)}
          >
            💬 Muốn nói gì thêm
          </button>
        )}
      </div>

      {moOGhiChu && (
        <div className="diem-danh-o-ghi-chu">
          <input
            type="text"
            value={ghiChuTam}
            onChange={(e) => setGhiChuTam(e.target.value)}
            placeholder="Hôm nay có gì muốn nói không? (không bắt buộc)"
            maxLength={500}
            autoFocus
          />
          <button
            type="button"
            className="diem-danh-nut-sua"
            onClick={() => {
              setMoOGhiChu(false);
              setGhiChuTam("");
            }}
          >
            bỏ ô này
          </button>
        </div>
      )}

      {coMat.length > 0 && (
        <p className="diem-danh-hang-ten">
          Hôm nay có mặt: <strong>{tenNguoiCoMat}</strong>
        </p>
      )}

      {bao && <div className="diem-danh-bao">{bao}</div>}
    </div>
  );
}

export default DiemDanh;
